import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { ErrorResponse } from '../../models/error.model';
import { MessageResponse } from '../../models/message.model';
import { AppService } from '../../models/app.service.model';
import { UserCompaniesResponse, UserResponse } from '../../models/user.model';
import { authToken } from '../../scripts/authentication.script';

export class ApiDigitalAuthUser {
  static apiResponse: ApiResponse

  public static async getUser(
    api_key: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let appServices: AppService[] | null = null
      let userResponse: UserResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/system.apps.data.json').then(response => { appServices = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/user.data.json').then(response => { userResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (appServices!.some(item => item.api_key === api_key)) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: userResponse!.success === true ? userResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/users`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then(response => {
        const payload = response.data?.data
        const userData = payload?.user ?? payload
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? userData : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async getMeCompanies(
    api_key: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let companiesResponse: UserCompaniesResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/companies.data.json').then(response => { companiesResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (companiesResponse!.success) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: companiesResponse!.success === true ? companiesResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/users/me/companies`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }

  public static async putUser(
    api_key: string,
    avatar: any,
    first_name: string,
    last_name: string,
    phone: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let appServices: AppService[] | null = null
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/system.apps.data.json').then(response => { appServices = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (appServices!.some(item => item.api_key === api_key)) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/users`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = new FormData()
      data.append('first_name', first_name)
      data.append('last_name', last_name)
      data.append('phone', phone)
      data.append('avatar', avatar)

      await axios.put(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }

  public static async putUserEmail(
    api_key: string,
    email: string,
    password: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let appServices: AppService[] | null = null
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/system.apps.data.json').then(response => { appServices = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (appServices!.some(item => item.api_key === api_key)) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/users/email`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        email: email,
        password: password
      }

      await axios.put(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }

  public static async putUserPassword(
    api_key: string,
    password: string,
    new_password: string,
    new_password_confirm: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let appServices: AppService[] | null = null
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/system.apps.data.json').then(response => { appServices = response.data.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (appServices!.some(item => item.api_key === api_key)) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/users/password`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        current_password: password,
        password: new_password,
        password_confirmation: new_password_confirm
      }

      await axios.put(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data.success === true ? response.data.data : null
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.success === false ? error.response.data.error : null
        }
      })
    }

    return this.apiResponse
  }
}
